export default __webpack_public_path__ + "static/media/09.997a9ba6.png";